export const STRING_CONSTANTS = {
  tools: {
    internalObject: "internalObjJimmypoint.com",
    internalArray: "internalArrayJimmypoint.com",
    jsonToString: {
      heading: "JSON to JSON string converter",
    },
    invalidJson: "Invalid JSON",
    outputHeight: 29,
  },
  global: {
    appName: "fireboxTools",
    domain: "fireboxTools.com",
    websiteURL: "https://www.fireboxtools.com",
  },
};
